import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Box, Typography, Link, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Fade } from '@mui/material'; // Animációhoz
import  TopicBox  from '../components/TopicBox.tsx';

const FreeTrialWebSites: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isAuthenticated = !!Cookies.get('token'); // Ellenőrzi a token meglétét

  useEffect(() => {
    // Szimuláljuk a betöltési időt
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Kategorizált free trial weboldalak
  const topics = [
    {
      category: 'Time & Utilities',
      emoji: '⏱️',
      description: 'Time zones, timers and random number generators to keep you on time.',
      links: [
        { name: 'Everytimezone', url: 'https://everytimezone.com', emoji: '🕰️', tooltip: 'Easily check time zones across the world in a visual way.' },
        { name: 'Eggtimer', url: 'https://e.ggtimer.com', emoji: '⏲️', tooltip: 'A simple countdown timer for productivity and focus.' },
        { name: 'Random.org', url: 'https://www.random.org', emoji: '🎲', tooltip: 'Generate true random numbers for lotteries, gaming, and more.' },
        { name: 'Roadtrippers', url: 'https://www.roadtrippers.com', emoji: '🗺️', tooltip: 'Plan road trips with maps, points of interest, and travel tips.' },
      ],
    },
    {
      category: 'Design & Typography Tools',
      emoji: '🖌️',
      description: 'Manage images and fonts, use the background remover and create custom fonts.',
      links: [
        { name: 'Remove Background', url: 'https://www.remove.bg', emoji: '✂️', tooltip: 'Instantly remove the background from any image with AI.' },
        { name: 'WhatTheFont', url: 'https://www.myfonts.com/WhatTheFont', emoji: '🔠', tooltip: 'Identify fonts from images using this AI-powered tool.' },
        { name: 'Fonts', url: 'https://fonts.google.com', emoji: '🔡', tooltip: 'Browse and download free Google Fonts for web and design projects.' },
        { name: 'Fontstruct', url: 'https://fontstruct.com', emoji: '✏️', tooltip: 'Create custom fonts using a simple grid-based editor.' },
        { name: 'Calligraphr', url: 'https://www.calligraphr.com', emoji: '🖋️', tooltip: 'Turn your handwriting into a custom font easily.' },
      ],
    },
    {
      category: 'Media & Communication & Learning',
      emoji: '🎥',
      description: 'Live streaming and online calls to stay in touch.',
      links: [
        { name: 'Youtube Webcam', url: 'https://www.youtube.com/webcam', emoji: '📹', tooltip: 'Go live on YouTube directly from your webcam.' },
        { name: 'Web Skype', url: 'https://web.skype.com', emoji: '☎️', tooltip: 'Use Skype directly in your browser without downloading the app.' },
      ],
    },
    {
      category: 'Document & File Tools',
      emoji: '📄',
      description: 'Edit, share and manage your documents with ease.',
      links: [
        { name: 'Pdfescape', url: 'https://www.pdfescape.com', emoji: '📝', tooltip: 'Edit PDFs online for free, without needing software.' },
        { name: 'Draw.io', url: 'https://app.diagrams.net', emoji: '📊', tooltip: 'Create flowcharts, diagrams, and mind maps easily.' },
        { name: 'Wetransfer', url: 'https://www.wetransfer.com', emoji: '📤', tooltip: 'Send large files quickly and securely online.' },
        { name: 'Drfone', url: 'https://www.drfone.wondershare.com', emoji: '📱', tooltip: 'A tool for phone data recovery, backup, and management.' },
      ],
    },
    {
      category: 'Price & Shopping Tools',
      emoji: '💰',
      description: 'Track price changes and save when you shop online.',
      links: [
        { name: 'Camelcamelcamel', url: 'https://camelcamelcamel.com', emoji: '🛒', tooltip: 'Track Amazon price history and get alerts on price drops.' },
      ],
    },
    {
      category: 'Home Design Tools',
      emoji: '🏠',
      description: 'Redesign your home with 3D modelling tools.',
      links: [
        { name: 'Homestyler', url: 'https://www.homestyler.com', emoji: '🛋️', tooltip: 'Create 3D home designs and room layouts online for free.' },
      ],
    },
  ];
  

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Particles háttér */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
        <Particles />
      </div>

      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      <Box sx={{ maxWidth: '100%', margin: 'auto', padding: 3, textAlign: 'center', mt: '64px', }}>
        <Fade in={true} timeout={1000}>
          <Typography variant="h1" sx={{ fontSize: '2.5rem', marginBottom: 2 }}>
            Explore Free Trial Websites 🕒
          </Typography>
        </Fade>
        <Fade in={true} timeout={1500}>
          <Typography variant="body1" sx={{ fontSize: '1.1rem', color: '#8a8888', marginBottom: 4 }}>
            Discover various free trial tools and resources available online. Click on the links below to explore! 🔗
          </Typography>
        </Fade>

        {/* Kategóriák rugalmas elrendezése */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center', paddingTop: 4 }}>
          {topics.map((topic) => (
            <TopicBox key={topic.category} topic={topic} />
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default FreeTrialWebSites;
